import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { getOrderKey } from '../utils';
import { CreateOrder } from '../action-creators';
import { CREATE_ORDER } from '../actions';
import AppState from '../../state';


export const createOrderCacheEpic = (action$: Observable<Actions>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Actions, CreateOrder>(
      CREATE_ORDER
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    map(([action, state]) => {
      const key = getOrderKey(state.artist.active?.id as string);

      localStorage.setItem(key, JSON.stringify(action.order));
    }),
    filter(() => false)
  );